const mutations = {
    setUser: (state, user) => {
        state.user = user
        if (user === null) {
            state.token = null
        }
    },
    setToken: (state, token) => {
        state.token = token
    },
};

export default mutations;